// tslint:disable:max-line-length

import React from 'react';

export const ProductBnP = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0 1.5C0 0.671573 0.671573 0 1.5 0H14.5C15.3284 0 16 0.671573 16 1.5C16 2.32843 15.3284 3 14.5 3H1.5C0.671573 3 0 2.32843 0 1.5Z" />
      <path d="M0 7.5C0 6.67157 0.671573 6 1.5 6H8.5C9.32843 6 10 6.67157 10 7.5C10 8.32843 9.32843 9 8.5 9H1.5C0.671573 9 0 8.32843 0 7.5Z" />
      <path d="M5.5 12C4.67157 12 4 12.6716 4 13.5C4 14.3284 4.67157 15 5.5 15H12.5C13.3284 15 14 14.3284 14 13.5C14 12.6716 13.3284 12 12.5 12H5.5Z" />
    </svg>
  );
};
